const BR = {
  governmentalOrganization: [
    "empresa pública",
    "sociedade de economia mista"
  ],
  listedPublicCompany: [
    "listed sociedade anônima (S.A.)"
  ],
  nonProfit: [
    "associação em sentido estrito (sem finalidade lucrativa)",
    "fundação privada",
    "fundação pública"
  ],
  privateCompany: [
    "sociedade limitada (Ltda.)",
    "sociedade simples",
    "Empresa Individual de Responsabilidade Limitada (EIRELI)"
  ]
};
export {
  BR as default
};
